import { Component, Input } from '@angular/core';
import { Emoji } from '../emoji';
import { EmojiPickerService } from '../emoji-picker.service';

@Component({
  selector: 'app-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.scss']
})

export class EmojiComponent {

  @Input()
  emoji: Emoji;

  @Input() maxWidth = 100;

  constructor(
    private _emojiPickerService: EmojiPickerService,
  ) { }

  select() {
    this._emojiPickerService.selectEmoji(this.emoji);
  }
}
